import type { VariantProps } from "class-variance-authority"
import { cva } from "class-variance-authority"

export const typographyVariants = cva(
	"prose prose-a:[overflow-wrap:anywhere] " +
		"prose-h1:text-[1.5rem] prose-h1:font-bold " +
		"prose-h2:text-[1.25rem] prose-h3:text-[1.125rem] " +
		"prose-h4:text-[1rem] prose-h5:text-[1rem] prose-h6:text-[1rem] " +
		"max-w-none [overflow-wrap:anywhere] dark:prose-invert " +
		"prose-a:no-underline hover:prose-a:cursor-pointer dark:prose-a:text-green-500 " +
		"[&>.is-empty]:text-tertiary tracking-tight " +
		"prose-blockquote:overflow-x-scroll prose-pre:overflow-x-auto " +
		"prose-pre:whitespace-pre-wrap prose-a:overflow-x-auto",
	{
		variants: {
			variant: {
				editor:
					"editor-typography prose-p:font-[400] [&>p:not(:first-child)]:!mt-4 [&_p:not(:first-child)]:!mt-4 " +
					"prose-img:rounded-lg prose-img:ring-0 " +
					"prose-img:border prose-img:border-gray-200 prose-img:bg-gray-100 " +
					"dark:prose-img:border-gray-800 dark:prose-img:bg-gray-800 " +
					// No width utility: it would override the stored width/height attrs that reserve the box before load.
					"prose-img:max-w-full prose-img:h-auto " +
					"prose-img:block prose-img:mx-auto " +
					"prose-blockquote:rounded-r-lg prose-blockquote:border prose-blockquote:border-l-4 " +
					"prose-blockquote:border-gray-200 prose-blockquote:border-l-gray-900 prose-blockquote:bg-gray-100 " +
					"dark:prose-blockquote:border-gray-700 dark:prose-blockquote:border-l-gray-200 dark:prose-blockquote:bg-gray-800 " +
					"prose-blockquote:px-4 prose-blockquote:py-px " +
					"prose-p:!mt-4 prose-p:text-secondary prose-li:text-secondary " +
					"prose-td:text-secondary prose-th:text-secondary placeholder:text-tertiary ",
				message:
					"message-typography prose-p:!py-0 text-[0.875rem] text-gray-800 dark:text-gray-300 leading-[1.45] prose-p:!my-0 prose-p:font-[450] " +
					// A blank line is an empty paragraph, so it has to keep its line box once the margins are gone.
					"[&_p:empty]:before:content-[''] [&_p:empty]:before:inline-block " +
					"prose-a:whitespace-pre-wrap " +
					"text-wrap flex-wrap overflow-auto select-text " +
					"focus:outline-none focus:ring-0 focus:border-transparent ",
			},
			mode: {
				noInvert: "",
				invert: "dark:prose-invert",
			},
		},
		defaultVariants: {
			mode: "invert",
		},
	},
)

export type typographyVariantsType = VariantProps<
	typeof typographyVariants
>["variant"]

export type typographyModeType = VariantProps<typeof typographyVariants>["mode"]
